export const SYSTEM_ROLES = {
  DEV: 0,
  MEMBER: 1,
  DASHBOARD_AGENT: 2,
  DASHBOARD_MANAGER: 3,
  BRAND_DASHBOARD_MANAGER: 4,
  SUPER_ADMIN: 5,
};

export const SYSTEM_ROLES_LABELS = {
  DEV: "Dev",
  SUPER_ADMIN: "Super Admin",
  MEMBER: "Member",
  DASHBOARD_MANAGER: "Dashboard Manager",
  DASHBOARD_AGENT: "Dashboard Agent",
  BRAND_DASHBOARD_MANAGER: "Brand Dashboard Manager",
};

export const SYSTEM_ROLES_OPTIONS = Object.entries(SYSTEM_ROLES).map(
  ([key, value]) => ({
    label: SYSTEM_ROLES_LABELS[key],
    value: String(value),
  })
);
